// extracted by mini-css-extract-plugin
export var container = "_ig-1";
export var cornerButtonContainer = "_ig-6";
export var disabled = "_ig-2";
export var dragActive = "_ig-3";
export var fileContainer = "_ig-5";
export var hiddenInput = "_ig-4";
export var widthContainer = "_ig-0";